const AlertDependent = ({ setError = null, alert_text, number_text = null }) => {
  return (
    <>
      <div className="AlertInnerBox AlertInnerBox2 YellowAlertInnerBox alert alert-dismissible fade show">
        <button
          type="button"
          className="close"
          data-dismiss="alert"
          onClick={() => setError(false)}>
          
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 7L7 17M7 7L17 17" stroke="#002F70" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
          </svg>
        </button>
        <div className="Icon_box">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a>
            <span className="material-symbols-outlined">warning</span>
          </a>
        </div>
        <div className="alert_text">
          <h6>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>{alert_text}</a>
          </h6>
          <p className="number_txt">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>{number_text}</a>
          </p>
        </div>
      </div>
    </>);

};

export default AlertDependent;